import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSection from '@/views/my-projects/components/MyProjectsSection.vue';
import InvoicesTable from '@/views/my-projects/components/invoices/InvoicesTable.vue';
import { computed } from 'vue';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesIncoming',
  setup(__props) {

const { componentInvoicesUserAsSender } = useInvoice();
const { userId, tUserFallback: t } = useUser('self');

const ingoingInvoices = computed(() => componentInvoicesUserAsSender.value.filter((invoice) => invoice.user.userId !== userId.value));

return { __sfc: true,componentInvoicesUserAsSender, userId, t, ingoingInvoices, MyProjectsSection, InvoicesTable }
}

})